/* eslint-disable @typescript-eslint/quotes */
/* eslint-disable @typescript-eslint/consistent-type-assertions */
/* eslint-disable prefer-arrow/prefer-arrow-functions */
/* eslint-disable @typescript-eslint/semi */
/* eslint-disable no-var */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable prefer-const */
/* eslint-disable guard-for-in */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable quote-props */
/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */
import { Component, ViewChild, OnInit, OnDestroy, ElementRef, NgZone, ChangeDetectorRef, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { EmitType } from '@syncfusion/ej2-base';
import { ContextMenuService, FilterSettingsModel, GridComponent, PageSettingsModel, ToolbarItems, ContextMenuItemModel, ToolbarService, PageService, EditService, ExcelExportProperties, ContextMenuOpenEventArgs } from '@syncfusion/ej2-angular-grids';
import { EditSettingsModel, TextWrapSettingsModel } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs, MenuEventArgs } from '@syncfusion/ej2-angular-navigations';
import { DialogComponent, DialogUtility } from '@syncfusion/ej2-angular-popups';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { WasabiService } from 'src/app/services/wasabi.service';
import { PersistedValueEnum } from 'src/app/models/persisted-value-enum';
import { AirAdStatusList } from 'src/app/models/airAdStatusList.model';
import { Client } from 'src/app/models/client.model';
import { Aircraft } from 'src/app/models/aircraft.model';
import { Document } from 'src/app/models/document.model';
import { taskListAd } from 'src/app/constant/taskListAd';
import { taskListMPD } from 'src/app/constant/taskListMPD';
import { taskListSBMOD } from 'src/app/constant/taskListSBMOD';
import { taskListRepairDamage } from 'src/app/constant/taskListRepairDamage';
import { ModalController } from '@ionic/angular';
import { StatusListComponent } from 'src/app/components/status-list/status-list.component';
import { TaskListAirWorthinessComponent } from 'src/app/components/tasklist-airworthiness/tasklist-airworthiness.component';
import { DatePipe } from '@angular/common';
import { TaskListEnum } from 'src/app/enums/taskList';
import * as XLSX from 'xlsx';
import { TaskListMPDComponent } from 'src/app/components/tasklist-mpd/tasklist-mpd.component';
import { TaskListSBMODComponent } from 'src/app/components/tasklist-sb-mod/tasklist-sb-mod.component';
import { ViewTableRowDetailComponent } from 'src/app/components/view-table-row-detail/view-table-row-detail.component';

@Component({
  selector: 'app-air-ad',
  templateUrl: './air-ad.page.html',
  styleUrls: ['./air-ad.page.scss'],
  providers: [ContextMenuService, ToolbarService, EditService, PageService]
})
export class AirAdPage implements OnInit, OnDestroy {
  @Input() isModel?: boolean = false
  @Input() data?: any = null
  @Input() assetId?: any = null
  @Input() eventId?: any = null
  public client: Client;
  public adList: any[];
  originalAdList: any = []
  adListFilteredData: any = []
  public searchText: string = '';
  public searchTextValueObj: any = null;
  public taskListArrayObj: any;
  public adListTemp: AirAdStatusList[] = [];
  public awdbSub: Subscription;
  public aircraftSub: Subscription;
  public aircraft: Aircraft;
  public pageSettings: PageSettingsModel;
  public wrapSettings: TextWrapSettingsModel;
  public filterOption: FilterSettingsModel = { type: 'Menu' };
  public toolbarOptions: ToolbarItems[] | object;
  public dialogVisibility = false;
  public dialogUDVisibility = false;
  public selectedAdId: string;
  public editSettings: EditSettingsModel;
  public fileLocation: string;
  public contextMenuItems: ContextMenuItemModel[];
  public aerfleId: number;
  public sList: number;
  public assetLoaded = false;
  public documentList: Document[];
  public isLoading: boolean = false;
  breadcrumbItems = [];
  airCraftData: any
  statusListObj: any
  assetMaintenanceMappingId: any
  headerName: string = ''
  @ViewChild('adGrid') public grid: GridComponent;
  @ViewChild('gridWrapper', { static: false }) gridWrapper!: ElementRef;
  @ViewChild('documentDialog') dialogObject!: DialogComponent;
  @ViewChild('documentImportDialog') dialogImportObject!: DialogComponent;
  @ViewChild('documentUDDialog') dialogUDObject!: DialogComponent;
  //@ViewChild('defaultupload')
  //public uploadObj: UploaderComponent;
  totalPages: number = 1; // Default total pages
  totalItems: number = 0; // Total records
  currentPage: number = 1;
  pageSize: number = 10000000;
  public displayedData: any = [];
  totalPagesArray: number[] = [];// Default page settings
  expandedRowIndex: number | null = null;
  showBulkUploadModel: boolean = false
  formattedRecordsExcelFIleData: any
  public bulkUploadTaskListSub: Subscription;
  public isSaving = false;
  refreshTriggerForDoc: number = 0;
  taskListTemplateURl: string = ''
  taskListEnums = TaskListEnum
  maintenanceTaskData: any
  taskListactiveRowId: any
  adDocumentLength: any = 0
  adComplianceComponentDocumentLength: any
  reviewStatusDropdown:any=['approved','approved with exception','discrepancy identified','discrepancy responded','pending review']
  reviewStatusValue:any=''
  statusClasses: any = {
  'pending review': 'tw-bg-gray-500',
  'discrepancy identified': 'tw-bg-red-500',
  'discrepancy responded': 'tw-bg-orange-500',
  'approved': 'tw-bg-green-800',
  'approved with exception': 'tw-bg-green-500'
};
  constructor(
    public apiService: ApiService,
    private wasabiService: WasabiService,
    private router: Router,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private modalController: ModalController,
    public datePipe: DatePipe,) {
    //using the line below  as ngOnInit because ngOnInit not firing after route.navigate
    route.params.subscribe(val => {
      this.aerfleId = val.aircraftId;
      this.sList = 1;
      this.isLoading = true
      // this.getAircraft();
    });


    this.totalPages = 1; // Default total pages
    this.totalItems = 0; // Total records
    this.currentPage = 1;
    this.pageSize = 10000000;
    this.totalPagesArray = [];// Default page settings
    this.displayedData = []

  }


  parseExcel(file) {
    var reader = new FileReader();
    reader.onload = (e) => {
      var data = (<any>e.target).result;
      var workbook = XLSX.read(data, {
        type: 'binary'
      });
      workbook.SheetNames.forEach((function (sheetName) {
        // Here is your object
        var XL_row_object = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
        this.adListTemp = XL_row_object as AirAdStatusList[];
        for (let i in this.adListTemp) {
          let tempValue: AirAdStatusList = {
            id: 0,
            adsId: 0,
            easa: this.adListTemp[i]["EASA"],
            faa: this.adListTemp[i]["FAA"],
            supercedes: this.adListTemp[i]["SUPERCEDES"],
            supercededBy: this.adListTemp[i]["SUPERCEDED BY"],
            description: this.adListTemp[i]["Description"],
            thresholdDate: this.formatDateToYYYYMMDD(this.parseDate(this.adListTemp[i]["THRESHOLD - DATE"])),
            thresholdTat: this.adListTemp[i]["THRESHOLD - TAT"],
            thresholdTac: this.adListTemp[i]["THRESHOLD - TAC"],
            repeatIntervalDate: this.formatDateToYYYYMMDD(this.parseDate(this.adListTemp[i]["REPEAT INTERVAL - DATE"])),
            repeatIntervalFh: this.adListTemp[i]["REPEAT INTERVAL - FH"],
            repeatIntervalFc: this.adListTemp[i]["REPEAT INTERVAL - FC"],
            lastDoneDate: this.formatDateToYYYYMMDD(this.parseDate(this.adListTemp[i]["LAST DONE - DATE"])),
            lastDoneTac: this.adListTemp[i]["LAST DONE - TAC"],
            lastDoneTat: this.adListTemp[i]["LAST DONE - TAT"],
            nextDueDate: this.formatDateToYYYYMMDD(this.parseDate(this.adListTemp[i]["NEXT DUE - DATE"])),
            nextDueTac: this.adListTemp[i]["NEXT DUE - TAC"],
            nextDueTat: this.adListTemp[i]["NEXT DUE - TAT"],
            meansAndMethodOfCompliance: this.adListTemp[i]["MEANS AND METHOD OF COMPLIANCE"],
            remarks: this.adListTemp[i]["Remarks'"],
            status: this.adListTemp[i]["Status'"],
            aerfleId: this.aerfleId,
          };
          this.grid.addRecord(tempValue);
        }
      }).bind(this), this);
    };

    reader.onerror = function (ex) {
      console.log(ex);
    };
    reader.readAsBinaryString(file);
    this.hideUDDialog();
  };



  parseDate(value: any): Date | null {
    if (value == null) return null;

    if (typeof value === 'number') {
      const baseDate = new Date(1899, 11, 30);
      return new Date(baseDate.getTime() + value * 86400000);
    } else if (typeof value === 'string') {
      const parsedDate = new Date(value);
      return isNaN(parsedDate.getTime()) ? null : parsedDate;
    } else {
      return null;
    }
  }


  // formatDateToYYYYMMDD(date: Date): string {
  //   if (date) {
  //     const year = date.getFullYear();
  //     const month = String(date.getMonth() + 1).padStart(2, '0');
  //     const day = String(date.getDate()).padStart(2, '0');

  //     return `${year}-${month}-${day}`;
  //   } else {
  //     return null;
  //   }
  // }

  public onFilechange(args: any): void {
    var files = args.target.files; // FileList object
    this.parseExcel(files[0]);
  }

  ngOnInit() {

    this.route.queryParams.subscribe(params => {
      this.airCraftData = params; // Save query parameters
      if (this.isModel === true) {
        this.airCraftData = this.data
        this.aerfleId = this.assetId
        this.sList = 1;
        this.isLoading = true
      }
      this.taskListArrayObj = this.airCraftData.task === 'ad' ? taskListAd : this.airCraftData.task === 'mpd' ? taskListMPD : this.airCraftData.task === 'sbMod' ? taskListSBMOD : taskListRepairDamage
      this.headerName = this.airCraftData.task === 'ad' ? this.taskListEnums.AIRWORTHINESSDIRECTIVESTATUS : this.airCraftData.task === 'mpd' ? this.taskListEnums.MPD : this.airCraftData.task === 'sbMod' ? this.taskListEnums.SBMOD : this.taskListEnums.REPAIRDAMAGE
      this.airCraftData.task === 'ad' ? this.taskListTemplateURl = 'assets/maintenance-task-template/Maintenance_task_AD_template.xlsx' : this.airCraftData.task === 'mpd' ? this.taskListTemplateURl = 'assets/maintenance-task-template/Maintenance_task_MPD_template.xlsx' : this.airCraftData.task === 'sbMod' ? this.taskListTemplateURl = 'assets/maintenance-task-template/Maintenance_task_SB_MOD_template.xlsx' : this.taskListTemplateURl = 'assets/maintenance-task-template/Maintenance_task_Repair_Damage_template.xlsx'
      this.airCraftData.task === 'ad' ? this.maintenanceTaskData = taskListAd : this.airCraftData.task === 'mpd' ? this.maintenanceTaskData = taskListMPD : this.airCraftData.task === 'sbMod' ? this.maintenanceTaskData = taskListSBMOD : this.maintenanceTaskData = taskListRepairDamage
      if (this.airCraftData && this.isModel === false) {
        this.breadcrumbItems = [
          { text: `${this.airCraftData?.assetName[0].toUpperCase() + this.airCraftData?.assetName.substr(1).toLowerCase()}/Maintenance Task`, link: `/assets/${this.airCraftData?.assetName.toLowerCase()}/${this?.aerfleId}` },
          { text: this.headerName, link: '' },
        ]
      }

    });

    this.client = JSON.parse(localStorage.getItem(PersistedValueEnum.client));
    //this.fileLocation = this.client.clientID+ '/MSN/SLISTS/'+ this.aerfleId+ '/'+this.sList;
    this.pageSettings = { pageSize: 25 };
    // this.wrapSettings = { wrapMode: 'Both' };
    // this.toolbarOptions = ['Add', 'Update', 'Cancel', 'Export Data', { text: 'Import from Excel', tooltipText: 'Import from Excel', prefixIcon: 'e-upload', id: 'import' }];
    // this.editSettings = { allowEditing: true, allowAdding: true, mode: 'Batch' };
    if(this.isModel === true){
      this.contextMenuItems = [
      { text: 'View', id: 'view', iconCss: 'e-icons e-file' },
      // { text: 'Compliance List', id: 'compliance',iconCss: 'e-icons e-paste' },
      // { text: 'Document List', id: 'documents', iconCss: 'e-icons e-file' },
    ];
    }else{
      this.contextMenuItems = [
        { text: 'View', id: 'view', iconCss: 'e-icons e-file' },
        { text: 'Edit', id: 'update', iconCss: 'e-icons e-edit' },
        { text: 'Delete', id: 'delete', iconCss: 'e-icons e-delete' },
        // { text: 'Compliance List', id: 'compliance',iconCss: 'e-icons e-paste' },
        // { text: 'Document List', id: 'documents', iconCss: 'e-icons e-file' },
      ];
    }
      this.getData();


  }
  public ngOnDestroy(): void {
    if (this.awdbSub !== null && this.awdbSub !== undefined) {
      this.awdbSub.unsubscribe();
    }
    if (this.aircraftSub !== null && this.aircraftSub !== undefined) {
      this.aircraftSub.unsubscribe();
    }
    if (this.bulkUploadTaskListSub !== null && this.bulkUploadTaskListSub !== undefined) {
      this.bulkUploadTaskListSub.unsubscribe();
    }
  }

  // public hideDialog: EmitType<object> = () => {
  //   this.dialogObject.hide();
  //   this.dialogVisibility = false;
  // };

  public hideUDDialog: EmitType<object> = () => {
    this.dialogUDObject.hide();
    this.dialogUDVisibility = false;
  };

  // public dialogButton: Object = [
  //   {
  //     'click': this.hideDialog.bind(this),
  //     buttonModel: {
  //       content: 'Close'
  //     }
  //   }
  // ];

  public getData(reviewStastusApply=false): void {
    if (this.searchText && !this.searchTextValueObj) {
      this.apiService.openErrorSnackBar('Please Select Search Value From DropDown')
      return
    }

     if(reviewStastusApply === false){
      this.reviewStatusValue = []
    }
    // this.adList = [];
    // const data = {
    //   recordID: 'all',
    //   parentID: this.aerfleId,
    //   statusListID: this.sList
    // };
    // this.adList = [];
    // this.awdbSub = this.apiService.getAirAD(data).subscribe((res: AirAdStatusList[]) => {
    //   try {
    //     if (res.length !== undefined) {
    //       this.adList = res;
    //     }
    //   } catch {
    //     console.error('Could not load Ad status data');
    //   }
    // });
    try {
      this.adList = []
      const params = {
        page: this.currentPage,
        limit: this.pageSize
      };
      if(this.eventId){
        params['eventId'] = this.eventId
      }
       if(this.reviewStatusValue?.length > 0){
        params["reviewStatus"] = this.reviewStatusValue.join(', ');
      }
      console.log(this.airCraftData?.task)
      console.log(this.airCraftData)
      switch (this.airCraftData?.task) {
        case 'ad':
          this.awdbSub = this.apiService.getAirWorthinessDirectivesByAssets(params, this.aerfleId, this.airCraftData?.assetTypeId, { searchedText: this.searchText, value: this.searchTextValueObj?.value }).subscribe((res: any) => {
            if (res?.data?.length !== undefined) {
              this.adList = res?.data ? res?.data : []
              this.totalItems = res.total_records; // Total records
              this.currentPage = res.current_page;
              this.pageSize = res.limit;
              this.calculateTotalPages();
              if (!this.searchText) {
                this.originalAdList = res?.data;
              }
            }
            this.isLoading = false
          }, (err: any) => {
            this.isLoading = false
            this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null)
            if(err?.status === 403 && this.isModel === false){
              this.router.navigate(
    [`/assets/${this.airCraftData?.assetName.toLowerCase()}/${this?.aerfleId}`],
    { queryParams: { mode: this.airCraftData?.mode,index:0 } }
  );
            }

          }), (err: any) => {
            this.isLoading = false
            this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null)
            if(err?.status === 403 && this.isModel === false){
              this.router.navigate(
    [`/assets/${this.airCraftData?.assetName.toLowerCase()}/${this?.aerfleId}`],
    { queryParams: { mode: this.airCraftData?.mode,index:0 } }
  );
            }
          };
          break;
        case 'mpd':
          this.awdbSub = this.apiService.getMpdByAssets(params, this.aerfleId, this.airCraftData?.assetTypeId, { searchedText: this.searchText, value: this.searchTextValueObj?.value }).subscribe((res: any) => {
            if (res?.data?.length !== undefined) {
              this.adList = res?.data ? res?.data : []
              this.totalItems = res.total_records; // Total records
              this.currentPage = res.current_page;
              this.pageSize = res.limit;
              this.calculateTotalPages();
              if (!this.searchText) {
                this.originalAdList = res?.data;
              }
            }
            this.isLoading = false
          }, (err: any) => {
            this.isLoading = false
            this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null)
            if(err?.status === 403 && this.isModel === false){
              this.router.navigate(
    [`/assets/${this.airCraftData?.assetName.toLowerCase()}/${this?.aerfleId}`],
    { queryParams: { mode: this.airCraftData?.mode,index:0 } }
  );
            }

          }), (err: any) => {
            this.isLoading = false
            this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null)
            if(err?.status === 403 && this.isModel === false){
              this.router.navigate(
    [`/assets/${this.airCraftData?.assetName.toLowerCase()}/${this?.aerfleId}`],
    { queryParams: { mode: this.airCraftData?.mode,index:0 } }
  );
            }
          };
          break;
        case 'repairDamage':
          this.awdbSub = this.apiService.getRepairDamageByAssets(params, this.aerfleId, this.airCraftData?.assetTypeId, { searchedText: this.searchText, value: this.searchTextValueObj?.value }).subscribe((res: any) => {
            if (res?.data?.length !== undefined) {
              this.adList = res?.data ? res?.data : []
              this.totalItems = res.total_records; // Total records
              this.currentPage = res.current_page;
              this.pageSize = res.limit;
              this.calculateTotalPages();
              if (!this.searchText) {
                this.originalAdList = res?.data;
              }
            }
            this.isLoading = false
          }, (err: any) => {
            this.isLoading = false
            this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null)
            if(err?.status === 403 && this.isModel === false){
              this.router.navigate(
    [`/assets/${this.airCraftData?.assetName.toLowerCase()}/${this?.aerfleId}`],
    { queryParams: { mode: this.airCraftData?.mode,index:0 } }
  );
            }

          }), (err: any) => {
            this.isLoading = false
            this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null)
            if(err?.status === 403 && this.isModel === false){
              this.router.navigate(
    [`/assets/${this.airCraftData?.assetName.toLowerCase()}/${this?.aerfleId}`],
    { queryParams: { mode: this.airCraftData?.mode,index:0 } }
  );
            }
          };
          break;
        case 'sbMod':
          this.awdbSub = this.apiService.getSbModByAssets(params, this.aerfleId, this.airCraftData?.assetTypeId, { searchedText: this.searchText, value: this.searchTextValueObj?.value }).subscribe((res: any) => {
            if (res?.data?.length !== undefined) {
              this.adList = res?.data ? res?.data : []
              this.totalItems = res.total_records; // Total records
              this.currentPage = res.current_page;
              this.pageSize = res.limit;
              this.calculateTotalPages();
              if (!this.searchText) {
                this.originalAdList = res?.data;
              }
            }
            this.isLoading = false
          }, (err: any) => {
            this.isLoading = false
            this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null)
            if(err?.status === 403 && this.isModel === false){
              this.router.navigate(
    [`/assets/${this.airCraftData?.assetName.toLowerCase()}/${this?.aerfleId}`],
    { queryParams: { mode: this.airCraftData?.mode,index:0 } }
  );
            }

          }), (err: any) => {
            this.isLoading = false
            this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null)
            if(err?.status === 403 && this.isModel === false){
              this.router.navigate(
    [`/assets/${this.airCraftData?.assetName.toLowerCase()}/${this?.aerfleId}`],
    { queryParams: { mode: this.airCraftData?.mode,index:0 } }
  );
            }
          };
          break;
      }

    } catch (err) {
      this.isLoading = false
      this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null)
      if(err?.status === 403 && this.isModel === false){
        this.router.navigate(
    [`/assets/${this.airCraftData?.assetName.toLowerCase()}/${this?.aerfleId}`],
    { queryParams: { mode: this.airCraftData?.mode,index:0 } }
  );
            }
    }
  }

  // public toolbarClick(args: ClickEventArgs): void {
  //   if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
  //     const excelExportProperties: ExcelExportProperties = {
  //       fileName: 'Airworthiness Directive Status - ' + this.aircraft.msn + '.xlsx'
  //     };
  //     this.grid.excelExport(excelExportProperties);
  //   }
  //   if (args.item.id === 'import') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
  //     try {
  //       this.dialogUDVisibility = true;
  //       this.dialogUDObject.show();
  //     } catch { }
  //   }
  // }

  // public batchSave(args): void {
  //   this.isLoading = true;


  //   const editedList: AirAdStatusList[] = args.batchChanges.changedRecords;
  //   const addedList: AirAdStatusList[] = args.batchChanges.addedRecords;

  //   const requests: Promise<any>[] = [];

  //   if (editedList.length > 0) {
  //     for (let i in editedList) {
  //       const data1 = {
  //         recordObj: editedList[i],
  //         statusListID: this.sList
  //       };

  //       requests.push(
  //         this.apiService
  //           .updateAirAD(data1).toPromise()
  //       );
  //       // this.awdbSub = this.apiService
  //       //   .updateAirAD(data1)
  //       //   .subscribe((data) => {
  //       //     // console.log(data);
  //       //   });
  //     }
  //   }

  //   if (addedList.length > 0) {
  //     this.isLoading = true;
  //     for (let i in addedList) {

  //       addedList[i].easa = addedList[i].easa ? addedList[i].easa : "";
  //       addedList[i].faa = addedList[i].faa ? addedList[i].faa : "";
  //       addedList[i].supercedes = addedList[i].supercedes ? addedList[i].supercedes : "";
  //       addedList[i].supercededBy = addedList[i].supercededBy ? addedList[i].supercededBy : "";
  //       addedList[i].description = addedList[i].description ? addedList[i].description : "";
  //       addedList[i].thresholdDate = addedList[i].thresholdDate ? addedList[i].thresholdDate : null;
  //       addedList[i].thresholdTat = addedList[i].thresholdTat ? addedList[i].thresholdTat : 0;
  //       addedList[i].thresholdTac = addedList[i].thresholdTac ? addedList[i].thresholdTac : 0;
  //       addedList[i].repeatIntervalDate = addedList[i].repeatIntervalDate ? addedList[i].repeatIntervalDate : null;
  //       addedList[i].repeatIntervalFh = addedList[i].repeatIntervalFh ? addedList[i].repeatIntervalFh : 0;
  //       addedList[i].repeatIntervalFc = addedList[i].repeatIntervalFc ? addedList[i].repeatIntervalFc : 0;
  //       addedList[i].lastDoneDate = addedList[i].lastDoneDate ? addedList[i].lastDoneDate : null;
  //       addedList[i].lastDoneTac = addedList[i].lastDoneTac ? addedList[i].lastDoneTac : 0;
  //       addedList[i].lastDoneTat = addedList[i].lastDoneTat ? addedList[i].lastDoneTat : 0;
  //       addedList[i].nextDueDate = addedList[i].nextDueDate ? addedList[i].nextDueDate : null;
  //       addedList[i].nextDueTac = addedList[i].nextDueTac ? addedList[i].nextDueTac : 0;
  //       addedList[i].nextDueTat = addedList[i].nextDueTat ? addedList[i].nextDueTat : 0;
  //       addedList[i].meansAndMethodOfCompliance = addedList[i].meansAndMethodOfCompliance ? addedList[i].meansAndMethodOfCompliance : "";
  //       addedList[i].remarks = addedList[i].remarks ? addedList[i].remarks : "";
  //       addedList[i].status = addedList[i].status ? addedList[i].status : "";
  //       addedList[i].aerfleId = this.aerfleId;
  //       const data1 = {
  //         recordObj: addedList[i],
  //         statusListID: this.sList
  //       };
  //       try {
  //         // this.awdbSub = this.apiService
  //         //   .addAirAD(data1)
  //         //   .subscribe((data) => {
  //         //     this.getData();
  //         //   });

  //         requests.push(
  //           this.apiService
  //             .addAirAD(data1).toPromise()
  //         );
  //       } catch { }
  //     }



  //     // Wait for all requests to complete
  //     Promise.all(requests).then(() => {
  //       this.isLoading = false;
  //       this.getData();
  //     }).catch(error => {
  //       console.error('Error in batchSave:', error);
  //       this.isLoading = false;
  //       // Optionally handle the error
  //     });
  //     // this.isLoading = false
  //   }
  // }

  public close() {
    this.router.navigate(['../assets/aircraft/' + this.aerfleId]);
  }

  // public contextMenuClick(args: MenuEventArgs): void {
  //   if (args.item.id === 'documents') {
  //     this.openDocs(this.grid.getSelectedRecords().map((e) => e['adsId']));
  //   }

  //   if (args.item.id === 'delete') {
  //     this.onOpenDialog();
  //   }
  // }

  public openDocs(id: string[]): void {
    this.selectedAdId = id[0];
    this.dialogVisibility = true;
    try {
      this.dialogObject.show();
    } catch { }
  }

  // public deleteDocs(id: string[]): void {
  //   this.selectedAdId = id[0];
  //   const dtd = {
  //     parentID: this.selectedAdId,
  //     recordID: 'all',
  //     statusListID: this.sList
  //   };
  //   this.awdbSub = this.apiService
  //     .getAirADDoc(dtd)
  //     .subscribe((res) => {
  //       this.documentList = res as [];
  //       for (let i in this.documentList) {
  //         this.wasabiService.deleteFile(this.fileLocation + '/' + this.selectedAdId, this.documentList[i].fileName);
  //       }
  //     });

  //   this.awdbSub = this.apiService
  //     .deleteAirADDoc(dtd)
  //     .subscribe((data1) => {
  //       const dtd1 = {
  //         recordID: this.selectedAdId,
  //         statusListID: this.sList,
  //         parentID: 'none',
  //       };
  //       this.awdbSub = this.apiService
  //         .deleteAirAD(dtd1)
  //         .subscribe((data2) => {
  //           this.getData();
  //           this.DialogObj.hide();
  //         });
  //     });
  // }

  public dismissModal(data: { AssetAdId: number, adDocumentLength?: number }): void {
    try {
      this.dialogObject?.hide();
      this.dialogVisibility = false;

      const expendedRowIndex = this.adList.findIndex(res => res?.id === data?.AssetAdId);
      if (expendedRowIndex !== -1) {
        this.taskListactiveRowId = data?.AssetAdId
        this.adDocumentLength = data?.adDocumentLength
      }

    } catch (err) {
      console.error('dismissModal error', err);
    }
  }


  public dismissUDModal(): void {
    try {
      this.dialogUDObject?.hide();
    } catch { }
    this.dialogUDVisibility = false;
  }

  public closeUD() {
    this.hideUDDialog();
  }

  // public DialogObj;
  // public onOpenDialog = function (): void {
  //   this.DialogObj = DialogUtility.confirm({
  //     title: 'Delete Confirmation',
  //     content: 'Delete selected Airworthiness Directive?',
  //     okButton: { text: 'OK', click: this.okClick.bind(this) },
  //     cancelButton: { text: 'Cancel', click: this.cancelClick.bind(this) },
  //     showCloseIcon: true,
  //     closeOnEscape: true,
  //     animationSettings: { effect: 'Zoom' }
  //   });
  // };

  // private okClick(): void {
  //   this.deleteDocs(this.grid.getSelectedRecords().map((e) => e['adsId']));
  // }

  // private cancelClick(): void {
  //   //Hide the dialog
  //   this.DialogObj.hide();
  // }

  // public getAircraft(): void {
  //   const data = {
  //     clientId: 'none',
  //     recordId: this.aerfleId,
  //   };

  //   this.aircraftSub = this.apiService
  //     .getAircraftById(data)
  //     .subscribe((airData) => {
  //       this.aircraft = airData[0];
  //       const test = new Date(this.aircraft.tatAsOfDate);
  //       this.assetLoaded = true;
  //       this.fileLocation = this.client.clientID + '/MSN/' + this.aircraft.msn.replace(' ', '-') + '/SLISTS/AIRWORTHINESSDSTATUS';
  //     });
  // }
  onRowDoubleClick(args: any) {
    console.log(args)
    let columnArray = this.airCraftData.task === 'ad' ? taskListAd : this.airCraftData.task === 'mpd' ? taskListMPD : this.airCraftData.task === 'sbMod' ? taskListSBMOD : taskListRepairDamage
      let eventItemObj:any=null
      if(this.eventId){
        eventItemObj= {
          type:'Add',
          taskListType: this.airCraftData.task === 'ad' ? 'AD' : this.airCraftData.task === 'mpd' ? 'MPD' : this.airCraftData.task === 'sbMod' ? 'SBMOD' : 'Repair Damage',
          eventId:this.eventId,
          assetObj:{ assetTypeId: this?.airCraftData?.assetTypeId, assetId: this?.aerfleId },
          taskListId: args?.rowData?.id,
          assetMaintenanceMappingId: args?.rowData?.assetMaintenanceMappingId
        }
      }
      console.log(args.rowData)
      this.ViewDetailData(columnArray, args.rowData, `View ${this.headerName} Details`, '875px',eventItemObj);
    // this.apiService.ViewDetailData(columnArray, args.rowData, `View ${this.headerName} Details`, '875px');
  }
  navigateToTask(args: any): void {
    const { id } = args.item;
    const { assetId } = args.rowInfo.rowData;
    this.assetMaintenanceMappingId = args.rowInfo.rowData?.assetMaintenanceMappingId
    // if (id === 'compliance') {
    //   this.router.navigate([`/air-task/${args.rowInfo.rowData?.assetMaintenanceMappingId}`], { queryParams: { assetId:this.aerfleId, assetTypeId:this.airCraftData?.assetTypeId,msn:this.airCraftData?.msn,manufacturer:this.airCraftData?.manufacturer,assetName:this.airCraftData?.assetName,task:this.airCraftData?.task,taskStatusId:args.rowInfo.rowData.id }});
    // } else  if (args.item?.id === 'documents') {
    //   this.openDocs(this.grid.getSelectedRecords().map((e) => e['adsId']));
    // } else
    if (args.item?.id === 'update') {
      this.addViewAirWorthinessDirective(this.airCraftData?.assetTypeId, assetId, this.statusListObj);
    }

    else if (args.item?.id === 'delete') {
      let columnArray = this.airCraftData.task === 'ad' ? taskListAd : this.airCraftData.task === 'mpd' ? taskListMPD : this.airCraftData.task === 'sbMod' ? taskListSBMOD : taskListRepairDamage
      let eventItemObj:any=null
      this.ViewDetailData(columnArray, args.rowInfo.rowData, `View ${this.headerName} Details`, '875px',eventItemObj,true);
    }
    else if (args?.item?.id === 'view') {
      console.log(args.rowInfo.rowData)
      let columnArray = this.airCraftData.task === 'ad' ? taskListAd : this.airCraftData.task === 'mpd' ? taskListMPD : this.airCraftData.task === 'sbMod' ? taskListSBMOD : taskListRepairDamage
      let eventItemObj:any=null
      if(this.eventId){
        eventItemObj= {
          type:'Add',
          taskListType: this.airCraftData.task === 'ad' ? 'AD' : this.airCraftData.task === 'mpd' ? 'MPD' : this.airCraftData.task === 'sbMod' ? 'SBMOD' : 'Repair Damage',
          eventId:this.eventId,
          itemId:args?.rowInfo?.rowData?.oilItemId,
          assetObj:{ assetTypeId: args?.rowInfo?.rowData?.assetTypeId, assetId: args?.rowInfo?.rowData?.assetId },
          taskListId:args?.rowInfo?.rowData?.id,
          assetMaintenanceMappingId:args?.rowInfo?.rowData?.assetMaintenanceMappingId
        }
      }
      this.ViewDetailData(columnArray, args.rowInfo.rowData, `View ${this.headerName} Details`, '875px',eventItemObj);
    }

    // if (id === 'documents') {
    //   this.router.navigate([`/air-doc/${assetStatusListId}`], { queryParams: { assetId } });
    // }
  }

  public async ViewDetailData(columnData:any,args?: any,pageName?:any,modelWidth?:string,addItemsData?:any,editableForm=false): Promise<void> {
      console.log(addItemsData)
          const modal = await this.modalController.create({
            component: ViewTableRowDetailComponent,
            cssClass: 'view-generic-modal',
            componentProps: { columnData: columnData , data:args,PageName:pageName,addItemsData:addItemsData || null,editableForm },
          });
          await modal.present();
          const modalElement = modal;
          if (modalElement) {
            modalElement.style.setProperty('--height', modelWidth || '350px');
          }
          const backdropElement = document.querySelector('ion-backdrop');
          if (backdropElement) {
            backdropElement.style.setProperty('backdrop-filter', 'blur(10px)');
            backdropElement.style.setProperty('background-color', 'rgba(0, 0, 0, 0.4)');  // Optional dark background shade
          }
          await modal.onDidDismiss().then(async (result) => {
            if (result.data && result.data.dismissed) {
            this.getData();
        // Refresh document list or perform another action
          }
          });
        }
  public contextMenuOpen(args: ContextMenuOpenEventArgs): void {
    if (!args.rowInfo || !args.rowInfo.rowData) {
      // Prevent the context menu from opening
      args.cancel = true;
    }
    const targetRow = args.rowInfo?.rowData;
    if (targetRow) {
      this.statusListObj = targetRow;
    }
  }

  applySearch(): void {
    if (!this.searchText) {
      //   const search = this.searchText.toString().toLowerCase();

      //   this.adListFilteredData = this.originalAdList.filter(item => {
      //     // Always present
      //     const statusListName = item.statusListName?.toString().toLowerCase().includes(search);

      //     // Dynamic field: model/type/mappingNumber
      //     const modelTypeMapping =
      //       this.airCraftData.task === 'mpd'
      //         ? item.model?.toString().toLowerCase().includes(search)
      //         : this.airCraftData.task === 'sbMod'
      //           ? item.type?.toString().toLowerCase().includes(search)
      //           : item.mappingNumber?.toString().toLowerCase().includes(search);

      //     // Dynamic field: faaAdNum / oemTaskNumber / mod_sb_stc_fcd_si / repairNumber
      //     const faaAdNumGroup =
      //       this.airCraftData.task === 'ad'
      //         ? item.faaAdNum?.toString().toLowerCase().includes(search)
      //         : this.airCraftData.task === 'mpd'
      //           ? item.oemTaskNumber?.toString().toLowerCase().includes(search)
      //           : this.airCraftData.task === 'sbMod'
      //             ? item.mod_sb_stc_fcd_si?.toString().toLowerCase().includes(search)
      //             : item.repairNumber?.toString().toLowerCase().includes(search);

      //     // Dynamic field: easaAdNum / operatorTaskNumber / eo_ea_ti / eoEaTi
      //     const easaAdNumGroup =
      //       this.airCraftData.task === 'ad'
      //         ? item.easaAdNum?.toString().toLowerCase().includes(search)
      //         : this.airCraftData.task === 'mpd'
      //           ? item.operatorTaskNumber?.toString().toLowerCase().includes(search)
      //           : this.airCraftData.task === 'sbMod'
      //             ? item.eo_ea_ti?.toString().toLowerCase().includes(search)
      //             : item.eoEaTi?.toString().toLowerCase().includes(search);

      //     return statusListName || modelTypeMapping || faaAdNumGroup || easaAdNumGroup;
      //   });
      //   this.displayedData = [...this.adListFilteredData];
      // } else {
      // this.displayedData = [...this.originalAdList];
      this.getData()
    }
  }



  calculateTotalPages() {
    this.totalPagesArray = []
    this.totalPages = Math.ceil(this.totalItems / this.pageSize);
    this.totalPagesArray = Array.from({ length: this.totalPages }, (_, i) => i + 1);
  }
  getPaginationRange(): (number | string)[] {
    const delta = 2; // how many pages to show around current page
    const range: (number | string)[] = [];
    const total = this.totalPages;
    const current = this.currentPage;

    const left = Math.max(2, current - delta);
    const right = Math.min(total - 1, current + delta);

    range.push(1); // Always show first page

    if (left > 2) {
      range.push('...');
    }

    for (let i = left; i <= right; i++) {
      range.push(i);
    }

    if (right < total - 1) {
      range.push('...');
    }

    if (total > 1) {
      range.push(total); // Always show last page
    }

    return range;
  }

  get displayedPages(): (number | string)[] {
    return this.getPaginationRange();
  }

  goToFirstPage() {
    if (this.currentPage > 1) {
      this.currentPage = 1;
      this.getData();
    }
  }

  goToLastPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage = this.totalPages;
      this.getData();
    }
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.getData();
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.getData();
    }
  }

  goToPage(page: number | string) {
    if (Number(page) !== this.currentPage) {
      this.currentPage = Number(page);
      this.getData();
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      const gridEl = this.gridWrapper.nativeElement;

      gridEl.addEventListener('click', (e: Event) => {
        const target = e.target as HTMLElement;

        if (target.tagName === 'A' && (target.classList.contains('e-dtdiagonalright') || target.classList.contains('e-dtdiagonaldown'))) {
          e.preventDefault();
        }
      });
    });
  }
  parentsUntil(element: HTMLElement, className: string): HTMLElement | null {
    while (element && !element.classList.contains(className)) {
      element = element.parentElement!;
    }
    return element;
  }
  onRowExpanding(e: any) {

    // Ensure that we can access row information whether expanding or collapsing
    const tr = e?.target ? this.parentsUntil(e.target as HTMLElement, 'e-row') : e?.rowIndex;


    let trIdx = e?.target ? parseInt(tr?.getAttribute('aria-rowindex') || '0') : (Number(tr) + 1);

    // If the row is not the currently expanded row, collapse the previous one (if any) and expand the clicked row
    if (this.expandedRowIndex !== trIdx) {
      if (this.expandedRowIndex) {
        this.grid.detailRowModule.collapse(this.expandedRowIndex - 1);
      }
      // Update the expanded row index
      this.expandedRowIndex = trIdx;
    } else {

      // If the clicked row is already expanded, collapse it
      this.grid.detailRowModule.collapse(trIdx);
      this.expandedRowIndex = null; // Reset the expanded row index
    }
  }
  public bulkUpload(): void {

    // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
    this.showBulkUploadModel = true
    this.dialogImportObject?.show()

  }
  public bulkUploadModelclose() {
    this.showBulkUploadModel = false
    this.dialogImportObject.hide()
  }
  public async addViewAirWorthinessDirective(assetTypeId: any, assetId: any, args?: any): Promise<void> {
    const modal = await this.modalController.create({
      component: this.headerName === this.taskListEnums.AIRWORTHINESSDIRECTIVESTATUS ? TaskListAirWorthinessComponent : this.headerName === this.taskListEnums.MPD ? TaskListMPDComponent : this.headerName === this.taskListEnums.SBMOD ? TaskListSBMODComponent : StatusListComponent,
      cssClass: 'add-log-page-modal-maintenace',
      componentProps: { assetTypeId, assetId, data: args || null },
    });
    await modal.present();
    this.apiService.maintenanceTaskAddEditModelHeightChangeUsingRepairCategory.subscribe(async value => {

      // Access the modal element
      const modalElement = document.querySelector('ion-modal');

      // Get the backdrop element of the modal
      const backdropElement = document.querySelector('ion-backdrop');

      if (modalElement) {
        // Set modal size and styling based on value
        // if (value) {
        //   modalElement.style.setProperty('--width', '720px');
        //   modalElement.style.setProperty('--height', '550px');
        // } else {
        modalElement.style.setProperty('--width', '940px');
        modalElement.style.setProperty('--height', '450px');
        // }
        if (this.airCraftData.task === 'repairDamage' || (args && args?.maintenanceTypeName === this.taskListEnums.REPAIRDAMAGE)) {
          modalElement.style.setProperty('--width', '720px');
          modalElement.style.setProperty('--height', '900px');
        }

        modalElement.style.setProperty('max-width', '100%');
        modalElement.style.setProperty('max-height', '100%');
        modalElement.style.setProperty('margin', 'auto');
        modalElement.style.setProperty('display', 'flex');
        modalElement.style.setProperty('flex-direction', 'column');
        modalElement.style.setProperty('justify-content', 'center');
        modalElement.style.setProperty('align-items', 'center');
      }

      // Apply background blur effect
      if (backdropElement) {
        backdropElement.style.setProperty('backdrop-filter', 'blur(10px)');
        backdropElement.style.setProperty('background-color', 'rgba(0, 0, 0, 0.4)');  // Optional dark background shade
      }
    });

    modal.onDidDismiss().then((result) => {
      if (result.data && result.data.dismissed) {
        // Refresh document list or perform another action
        this.getData();
      }
    });
  }

  public toolbarClick(assetTypeId: any, assetId: any): void {
    // if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
    //     this.grid.excelExport();
    // }

    // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
    this.addViewAirWorthinessDirective(assetTypeId, assetId);

  }

  public submitBulkUpload(): void {
    try {
      if (!this.formattedRecordsExcelFIleData) {
        this.apiService.openErrorSnackBar('Please Upload File!', null)
        return;
      }
      this.isSaving = true
      let data
      if (this.airCraftData.task !== 'repairDamage') {
        data = { recordObj: this.formattedRecordsExcelFIleData, assetTypeId: this.airCraftData?.assetTypeId, assetId: this.aerfleId }
        this.bulkUploadTaskListSub = this.apiService.uploadBulkMaintenanceTasks(data).subscribe((res: any) => {
          if (res !== null) {
            this.apiService.openSnackBar('Data Uploaded Successfully', null)
            this.formattedRecordsExcelFIleData = null
            this.bulkUploadModelclose()
            this.getData();
          }
          this.isSaving = false
        }, (err: any) => {
          this.isSaving = false;
          this.bulkUploadModelclose()
          this.apiService.openBulkErrorSnackBarForTaskList(err?.error?.errorRecords ? err?.error?.errorRecords : [], null)

        }), (err: any) => {
          this.isSaving = false;
          this.bulkUploadModelclose()
          this.apiService.openBulkErrorSnackBarForTaskList(err?.error?.errorRecords ? err?.error?.errorRecords : [], null)
        };
      }
      else {
        data = this.formattedRecordsExcelFIleData
        this.bulkUploadTaskListSub = this.apiService.uploadBulkRepairDamage(data).subscribe((res: any) => {
          if (res !== null) {
            this.apiService.openSnackBar('Data Uploaded Successfully', null)
            this.formattedRecordsExcelFIleData = null
            this.bulkUploadModelclose()
            this.getData();
          }
          this.isSaving = false
        }, (err: any) => {
          this.isSaving = false;
          this.bulkUploadModelclose()
          this.apiService.openBulkErrorSnackBarForTaskList(err?.error?.errorRecords ? err?.error?.errorRecords : [], null)

        }), (err: any) => {
          this.isSaving = false;
          this.bulkUploadModelclose()
          this.apiService.openBulkErrorSnackBarForTaskList(err?.error?.errorRecords ? err?.error?.errorRecords : [], null)
        };
      }


    }
    catch (err) {
      this.isSaving = false;
      this.apiService.openBulkErrorSnackBarForTaskList(err?.error?.errorRecords ? err?.error?.errorRecords : [], null)
    }
  }
  onFileSelect(event: any): void {
    const file = event.target.files[0];

    if (file) {
      // Validate file type (only accept Excel files)
      const fileType = file.name.split('.').pop();
      if (fileType !== 'xls' && fileType !== 'xlsx') {
        this.apiService.openErrorSnackBar('Only Excel files (.xls, .xlsx) are allowed!', null)
        // alert('Only Excel files (.xls, .xlsx) are allowed!');
        return;
      }

      // Read the file using FileReader
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });

        // Assume the first sheet contains the data
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];

        // Convert sheet data to JSON
        const excelData = XLSX.utils.sheet_to_json(worksheet);

        // Convert Excel rows to structured JSON format
        this.formattedRecordsExcelFIleData = this.formatExcelData(excelData);
        console.log(this.formattedRecordsExcelFIleData)
        // You can now send `formattedRecords` to your backend API
      };

      reader.readAsArrayBuffer(file);
    }
  }

  formatExcelData(excelData: any[]): any {
    return {

      records: excelData.map(row => {
        if (this.airCraftData.task !== 'repairDamage') {
          return {
            maintenanceType: this.headerName || null,
            mappingNumber: this.apiService.getRowValue(row, 'Mapping Number'),
            eoEaTi: this.apiService.getRowValue(row, 'EO/EA/TI #'),
            repairClassification: this.apiService.getRowValue(row, 'Repair Classification'),
            ataChapter: this.apiService.getRowValue(row, 'ATA Chapter'),
            description: this.apiService.getRowValue(row, 'Description'),
            approvedDataSrmReference: this.apiService.getRowValue(row, 'Approved Data/SRM Reference'),
            approvedDataSrmRevisionNumber: this.apiService.getRowValue(row, 'Approved Data/SRM Revision Number'),
            repairDamage: this.apiService.getRowValue(row, 'Repair Damage'),
            taskId: this.apiService.getRowValue(row, 'Task Id'),
            thresholdTat: this.apiService.getRowValue(row, 'Threshold Tat'),
            thresholdTac: this.apiService.getRowValue(row, 'Threshold Tac'),
            thresholdDate: this.apiService.excelToJSDate(this.apiService.getRowValue(row, 'Threshold Date')) || null,
            thresholdDays: this.apiService.getRowValue(row, 'Threshold Days') || null,
            repeatIntervalFh: this.apiService.getRowValue(row, 'Repeat Interval Fh'),
            repeatIntervalFc: this.apiService.getRowValue(row, 'Repeat Interval Fc'),
            repeatIntervalDays: this.apiService.getRowValue(row, 'Repeat Interval Days'),
            approved_data_reference: this.apiService.getRowValue(row, 'Approved Data Reference'),
            oemTaskNumber: this.apiService.getRowValue(row, 'OEM Task Number'),
            easaAdNum: this.apiService.getRowValue(row, 'Easa Ad Num'),
            faaAdNum: this.apiService.getRowValue(row, 'Faa Ad Num'),
            otherAd: this.apiService.getRowValue(row, 'Other AD'),
            additionalRequirement: this.apiService.getRowValue(row, 'Additional Requirement'),
            repairCategory: this.apiService.getRowValue(row, 'Repair Category'),
            occurrenceAlertThreshold: this.apiService.getRowValue(row, 'Occurrence Alert Threshold'),
            occurrenceAlertRepeatInterval: this.apiService.getRowValue(row, 'Occurrence Alert Repeat Interval'),
            mod_sb_stc_fcd_si: this.apiService.getRowValue(row, 'MOD/SB/STC/FCD/SI'),
            repairNumber: this.apiService.getRowValue(row, 'Repair Number'),
            status: this.apiService.getRowValue(row, 'Status'),
            operatorTaskNumber: this.apiService.getRowValue(row, 'Operator Task Number'),
            lastDoneFlightHours: this.apiService.getRowValue(row, 'Last Done Flight Hours'),
            lastDoneFlightCycles: this.apiService.getRowValue(row, 'Last Done Flight Cycles'),
            lastDoneDate: this.apiService.excelToJSDate(this.apiService.getRowValue(row, 'Last Done Date')) || null,
            taskCardNumber: this.apiService.getRowValue(row, 'Task Card Number'),
            complianceRemarks: this.apiService.getRowValue(row, 'Compliance Remarks'),
            sourceTaskReference: this.apiService.getRowValue(row, 'SOURCE TASK REFERENCE')
          }
        }
        else {
          return {
            maintenanceTypeId: 6,
            mappingNumber: this.apiService.getRowValue(row, 'Mapping Number'),
            eoEaTi: this.apiService.getRowValue(row, 'EO/EA/TI #'),
            repairClassification: this.apiService.getRowValue(row, 'Repair Classification'),
            repairNumber: this.apiService.getRowValue(row, 'Repair Number'),
            ataChapter: this.apiService.getRowValue(row, 'ATA Chapter'),
            description: this.apiService.getRowValue(row, 'Description'),
            approvedDataSrmReference: this.apiService.getRowValue(row, 'Approved Data/SRM Reference'),
            approvedDataSrmRevisionNumber: this.apiService.getRowValue(row, 'Approved Data/SRM Revision Number'),
            repairDamage: this.apiService.getRowValue(row, 'Repair Damage'),
            woNrcDfpRef: this.apiService.getRowValue(row, 'WO / NRC / DFP REF.'),
            performedDate: this.apiService.excelToJSDate(this.apiService.getRowValue(row, 'Performed Date')) || null,
            performedTac: this.apiService.getRowValue(row, 'Performed TAC'),
            performedTat: this.apiService.getRowValue(row, 'Performed TAT'),
            initialComplianceRemarks: this.apiService.getRowValue(row, 'Initial Compliance Remarks'),
            assetMaintenance: {
              assetId: this.aerfleId,
              thresholdTat: this.apiService.getRowValue(row, 'Threshold Tat'),
              thresholdTac: this.apiService.getRowValue(row, 'Threshold Tac'),
              thresholdDate: this.apiService.excelToJSDate(this.apiService.getRowValue(row, 'Threshold Date')) || null,
              repeatIntervalFh: this.apiService.getRowValue(row, 'Repeat Interval Fh'),
              repeatIntervalFc: this.apiService.getRowValue(row, 'Repeat Interval Fc'),
              repeatIntervalDays: this.apiService.getRowValue(row, 'Repeat Interval Days'),
              approved_data_reference: this.apiService.getRowValue(row, 'Approved Data Reference'),
              additionalRequirement: this.apiService.getRowValue(row, 'Additional Requirement'),
              repairCategory: this.apiService.getRowValue(row, 'Repair Category'),
              occurrenceAlertThreshold: this.apiService.getRowValue(row, 'Occurrence Alert Threshold'),
              occurrenceAlertRepeatInterval: this.apiService.getRowValue(row, 'Occurrence Alert Repeat Interval'),
              status: this.apiService.getRowValue(row, 'Status'),
              lastDoneFlightHours: this.apiService.getRowValue(row, 'Last Done Flight Hours'),
              lastDoneFlightCycles: this.apiService.getRowValue(row, 'Last Done Flight Cycles'),
              lastDoneDate: this.apiService.excelToJSDate(this.apiService.getRowValue(row, 'Last Done Date')) || null,
              taskCardNumber: this.apiService.getRowValue(row, 'Task Card Number'),
              complianceRemarks: this.apiService.getRowValue(row, 'Compliance Remarks'),
            }


          }

        }

      })
    };
  }
  handleDataCreated(data: { AssetAdId: number, adComplianceDocumentsList?: any }) {
    this.refreshTriggerForDoc++; // change to trigger OnChanges
    const expendedRowIndex = this.adList.findIndex(res => res?.id === data.AssetAdId);
    if (expendedRowIndex !== -1) {
      this.taskListactiveRowId = data.AssetAdId
      this.adDocumentLength = this.adDocumentLength
      this.adComplianceComponentDocumentLength = data?.adComplianceDocumentsList?.length
      this.cdr.detectChanges()
    }
  }
  excelExport() {
    // First construct export data
    const exportData = this.adList.map((item) => {
      const row = {} as any;

      this.maintenanceTaskData.forEach((col) => {
        row[col.header] = item[col.value] ? item[col.value] : '';
      });

      return row;
    });

    // Create a new workbook and export
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(exportData);
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Export');

    // Save to a file
    const fileName = this.headerName + '.xlsx';
    XLSX.writeFile(workbook, fileName);
  }

  closeModal() {
    this.modalController.dismiss({
      dismissed: false,
    });
  }
  isAllSelected(): boolean {
  return this.reviewStatusValue.length > 0 && this.reviewStatusDropdown.every(f => this.reviewStatusValue.includes(f));
  }

  toggleSelectAll(): void {
    this.reviewStatusValue = this.isAllSelected() ? [] : [...this.reviewStatusDropdown];
  }




}
